import { OAUTH_CLIENT_ID } from '../env.ts';

export const getXAuthLink = (username: string) => {
  const url = new URL(window.location.href);

  url.searchParams.append('xcom', 'true');

  const state = `redirectPathname:${url.pathname}${url.search}%2F${username}`;

  return `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${OAUTH_CLIENT_ID}&redirect_uri=${window.location.origin}/xauth&scope=tweet.read%20users.read%20follows.read&state=${state}&code_challenge=challenge&code_challenge_method=plain`;
};
